import moment from 'moment'

import { DATE_FORMAT } from 'config/consts'

const getColName = (cols = [], dataField) => {
	const { caption } = cols.find(item => item.dataField === dataField) || {}
	return caption
}

/*
	Accepts obj with keys 'rows', 'columns' values from DxDataTable and 'xCol', 'groupBy' from filter as first argument
	and column's accessor which value to return.
	Returns object {
		data: array which can be used as data in charts
		dataKey: string which can be used as 'dataKey' prop in charts
	}
*/
export default ({ rows, columns, xCol, groupBy }, valueCol = 'total') => {
	const dataKey = getColName(columns, valueCol)
	let data = []
	if(groupBy) { // Manually calculate group values
		const groupedVals = rows.reduce((out, row) => {
			const sumVal = Number(row[valueCol])
			if(!isNaN(sumVal)) {
				const key = row[groupBy]
				if(!out[key]) {
					out[key] = sumVal
				} else {
					out[key] += sumVal
				}
			}
			return out
		}, {})
		data = Object.keys(groupedVals).map(key => {
			const name = xCol === 'dateTime' ? moment(key).format(DATE_FORMAT) : key
			return { name, [dataKey]: groupedVals[key] }
		})
	} else {
		data = rows.reduce((outArr, row, i) => {
			const sumVal = Number(row[valueCol])
			if(!isNaN(sumVal)) {
				const caption = xCol === 'dateTime'
					? moment(row[xCol]).format(DATE_FORMAT)
					: row[xCol]
				outArr.push({ name: caption, [dataKey]: sumVal })
			}
			return outArr
		}, [])
	}
	return { data, dataKey }
}
